import { PDFDocument } from 'pdf-lib';

export type PdfSignatureFile = Blob & {
  name?: string;
  hasSignatures?: boolean;
};

export const checkPdfSignatures = async (
  file: PdfSignatureFile
): Promise<boolean> => {
  file.hasSignatures = false;

  const isPdf =
    file.name?.toLowerCase().endsWith('.pdf') ||
    file.type?.toLowerCase().split(';')[0] === 'application/pdf';

  if (!isPdf) return false;

  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdfDocument = await PDFDocument.load(arrayBuffer, {
      ignoreEncryption: true
    });
    const acroForm = pdfDocument.catalog?.getAcroForm();
    const acroFields = acroForm?.getFields();

    file.hasSignatures = !!acroFields?.some(([field]) => {
      if (field?.constructor.name.toLowerCase().includes('signature')) {
        return true;
      }

      const fieldDictionary = field?.dict as any;
      const dictValues = fieldDictionary?.dict?.values?.() || [];
      for (const dictValue of dictValues) {
        if (dictValue?.encodedName === '/Sig') return true;
      }

      return false;
    });

    return file.hasSignatures;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'Erro ao verificar se PDF possui assinaturas. Considerando que não possui.',
      file,
      error
    );
    file.hasSignatures = false;
    return false;
  }
};
